import React from 'react';
import NodeEditor from './NodeEditor';
import EdgeEditor from './EdgeEditor';

const GraphCustomizeTab = ({
  graphData,
  setGraphData,
  nextNodeId,
  setNextNodeId,
  edgeForm,
  setEdgeForm,
  addNode,
  addEdge,
  deleteNode,
  deleteNodeWithConfirmation,
  exportGraph,
  importGraph
}) => {
  return (
    <div className="control-panel">
      <h3>Graph Customize</h3>
      
      
      <div className="graph-editing-section">
        <h4>Graph Editing</h4>
        
        <NodeEditor
          addNode={addNode}
        />
        
        <EdgeEditor
          graphData={graphData}
          edgeForm={edgeForm}
          setEdgeForm={setEdgeForm}
          addEdge={addEdge}
        />
      </div>
      
      <div className="node-deletion-section">
        <h4>Delete Nodes</h4>
        <div className="delete-controls">
          <p className="delete-warning">
            ⚠️ <strong>Warning:</strong> Deleting a node will also remove all connected edges.
          </p>
          <div className="node-list">
            {graphData.nodes.map(node => (
              <div key={node.id} className="node-item">
                <span className="node-info">
                  {node.label} (ID: {node.id})
                </span>
                <button 
                  className="delete-node-btn"
                  onClick={() => deleteNodeWithConfirmation(node.id)}
                  disabled={graphData.nodes.length <= 1}
                  title={graphData.nodes.length <= 1 ? "Cannot delete the last node" : `Delete ${node.label} and all connected edges`}
                >
                  🗑️ Delete
                </button>
              </div>
            ))}
          </div>
          {graphData.nodes.length <= 1 && (
            <p className="min-nodes-warning">
              At least one node is required to maintain a valid graph.
            </p>
          )}
        </div>
      </div>
      
      <div className="import-export-section">
        <h4>Import & Export</h4>
        
        <div className="file-controls">
          <button className="export-btn" onClick={exportGraph}>
            Export Graph
          </button>
          <button className="import-btn" onClick={importGraph}>
            Import Graph
          </button>
        </div>
        
        <div className="file-info">
          <p>Export current graph as JSON or import a new graph file.</p>
        </div>
      </div>
      
      <div className="graph-info-section">
        <h4>Graph Information</h4>
        <div className="info-stats">
          <p><strong>Nodes:</strong> {graphData.nodes.length}</p>
          <p><strong>Edges:</strong> {graphData.edges.length}</p>
          <p><strong>Graph Type:</strong> Undirected</p>
        </div>
      </div>
      
      <div className="update-graph-section">
        <h4>Finalize Changes</h4>
        <div className="update-controls">
          <button 
            className="update-graph-btn" 
            onClick={() => {
              // Force a re-render by creating new object references
              setGraphData({
                nodes: [...graphData.nodes],
                edges: [...graphData.edges]
              });
              console.log('Graph updated - nodes:', graphData.nodes.length, 'edges:', graphData.edges.length);
              alert('Graph updated successfully! Changes are now visible in all tabs.');
            }}
            style={{
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            ✅ Update Graph
          </button>
          <p className="update-info">
            Click to finalize all changes and make them visible in Algorithm Mode and Custom Path tabs.
          </p>
        </div>
      </div>
    </div>
  );
};

export default GraphCustomizeTab;
